import React, {useState, useEffect} from 'react'

type ButtonListProps = {
    items: {
        label: any
        value: any
        disabled?: boolean | null
    }[]
    className?: (selected: boolean, item?:any) => string | null
    onClick?: (value: any) => void
    selected: any | null
    styles?: any
}

const ButtonList: React.FC<ButtonListProps> = ({items, className, onClick, selected, styles}) => {

    // State to keep track of the selected button index
    const [selectedButton, setSelectedButton] = useState<number | null>(selected)

    useEffect(() => {
        setSelectedButton(selected)
    }, [selected])


    return (
        <>
            {items?.map((item, index) => (

                <button
                    key={index}
                    className={`transition-all select-none ${className ? className(item.value === selectedButton, item) : ''} ${
                        styles?.[index] ? styles[index] : ''
                    }`}

                    onClick={() => {
                        if (selectedButton !== item.value) {
                            setSelectedButton(item.value)
                            if (onClick) {
                                onClick(item.value)
                            }
                        }
                    }} // Set the selected button index when clicked
                    title={item?.value}
                >
                    {item.label}
                </button>
            ))}
        </>
    )
}

export default ButtonList
